import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("p", { class: "ml-2 font-bold text-sm" }, "DESCARGAR", -1)
const _hoisted_2 = { class: "text-center mb-4" }
const _hoisted_3 = /*#__PURE__*/_createVNode("p", null, "La solicitud del reporte puede tomar bastante tiempo, se te notificará cuando este disponible en la sección \"Reportes\"", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fa_icon = _resolveComponent("fa-icon")
  const _component_ui_button = _resolveComponent("ui-button")
  const _component_ui_modal = _resolveComponent("ui-modal")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", {
      class: "flex items-center cursor-pointer text-white",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.modalState = true))
    }, [
      _createVNode(_component_fa_icon, {
        icon: ['fas', 'file-download'],
        size: "lg"
      }),
      _hoisted_1
    ]),
    _createVNode(_component_ui_modal, {
      modalState: _ctx.modalState,
      "onUpdate:modalState": _cache[3] || (_cache[3] = ($event: any) => (_ctx.modalState = $event))
    }, {
      default: _withCtx(() => [
        _createVNode("div", _hoisted_2, [
          _createVNode(_component_fa_icon, {
            class: "mt-4 mb-7 text-yellow-500",
            icon: ['fas', 'exclamation-triangle'],
            size: "lg",
            style: {"transform":"scale(2)"}
          }),
          _hoisted_3
        ]),
        _createVNode(_component_ui_button, {
          label: "OK",
          onClick: _ctx.report
        }, null, 8, ["onClick"]),
        _createVNode("p", {
          class: "text-center text-yellow-800 py-2 select-none cursor-pointer hover:bg-gray-50 rounded-md transition-all duration-300",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.modalState = false))
        }, "Cancelar")
      ]),
      _: 1
    }, 8, ["modalState"])
  ], 64))
}